import React, { useEffect, useState } from 'react';
import ReactDOM from "react-dom";
import { usePost } from "seed/api";
import { useDetail, useSet } from "seed/gql";
import { SET_CHAT } from "seed/gql/queries";
import { Loading } from 'seed/helpers';
import WSManager from "components/util/ws";
import l from "components/util/l";
import Chat from "components/presentation/chat/Chat";
import HelpMessage from 'components/util/helpers/HelpMessage';
import "styles/css/util/helpers/Wizard.css";

const Wizard = ({
  flow,
  mainProcessName,
  helpMessage = null,
  params = {},
  helpMessagePlacement = "top",
  buttonClassName = "",
  buttonStyle = {},
  onCompleted = () => { },
  onAborted = () => { },
}) => {

  const width = 500;
  const height = 700;

  const [chatPosition, setChatPosition] = useState({ top: 0, left: 0 });
  const [showChatPopup, setShowChatPopup] = useState(false);

  const onClickExecute = (e) => {

    e.preventDefault();
    e.stopPropagation();

    const buttonRect = e.currentTarget.getBoundingClientRect();
    const popupWidth = width;
    const popupHeight = height;
    const padding = 10;

    let top = buttonRect.bottom + padding;
    let left = buttonRect.right + padding;

    if (left + popupWidth > window.innerWidth)
      left = buttonRect.left - popupWidth - padding;

    if (left < 0)
      left = window.innerWidth - popupWidth - padding;

    if (top + popupHeight > window.innerHeight)
      top = buttonRect.top - popupHeight - padding;

    if (top < 0)
      top = padding;

    setChatPosition({ top, left });
    setShowChatPopup(true);

  }

  const onClickCloseChat = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    setShowChatPopup(false);
  }

  return <div>
    <HelpMessage message={helpMessage || l("Asesor%GA094")} forceShow={true} placement={helpMessagePlacement}>
      <button
        type="button"
        style={buttonStyle}
        className={`btn btn-advisor btn-outline-accent ${buttonClassName}`}
        onClick={onClickExecute}
      >
        <i class="fas fa-wand-magic-sparkles"></i>
      </button>
    </HelpMessage>

    {showChatPopup && ReactDOM.createPortal(
      <div
        id="wizard"
        className={`card card-body p-0 position-relative bg-white`}
        style={{
          width,
          height,
          top: chatPosition.top,
          left: chatPosition.left
        }}
      >

        <div className='close-wrapper'>
          <button
            type="button"
            className="btn btn-sm px-0 py-0"
            onClick={onClickCloseChat}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className='d-flex h-100 w-100'>
          <WizardChat
            flow={flow}
            mainProcessName={mainProcessName}
            params={params}
            width={width}
            height={height}
            chatPosition={chatPosition}
            isCard={true}
            onClickCloseChat={onClickCloseChat}
            onAborted={onAborted}
            onCompleted={onCompleted}
          />
        </div>

      </div>,
      document.body
    )}
  </div>

}

const WizardChat = ({
  flow,
  mainProcessName = null,
  subProcessName = null,
  params = {},
  hideTitle = false,
  subtitle = null,
  isCard = false,
  onClickCloseChat = () => { },
  onWizardMessage = () => { },
  onCompleted = () => { },
  onAborted = () => { },
  onStep = () => { }
}) => {

  const [chat, setChat] = useState(null);
  const [execution, setExecution] = useState(null);
  const [executionData, setExecutionData] = useState(null);
  const [isClosing, setIsClosing] = useState(false);
  const [wizardSessionId, setWizardSessionId] = useState(crypto.randomUUID());
  const [isWizardAvailable, setIsWizardAvailable] = useState(true);
  const wizardRoomName = `WIZARD_STATUS_${flow?.id}`;

  const onExecutionMessage = (data) => {
    setExecutionData(data);
  }

  const closeAuto = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClickCloseChat();
    }, 3500);
  }

  const [callSetRead] = useSet(SET_CHAT);
  const [callExecuteWizard] = usePost("/chats/create_execution_wizard", {
    onCompleted: (data) => {
      if (chat && subProcessName) {
        setExecution(data.execution);
      }
      else {
        callSetRead({ id: data.chat.id, isRead: true });
        setChat(data.chat);
        setExecution(data.execution);
      }
    },
    onError: (error) => {
      setIsWizardAvailable(false);
      closeAuto();
    }
  });

  const reqGetExecutionDetails = useDetail(`{
    execution {
      id
      status
      lastStep {
        result
        flowNode {
          outputValues
        }
      }
    }
  }`, executionData?.execution_id, {
    onCompleted: ({ execution }) => {

      console.log(execution)

      if (execution.status == "OK") {

        onCompleted(execution);

        if (subProcessName) {
          callExecuteWizard({
            node_name: subProcessName,
            flow_id: flow.id,
            params: params,
            session_id: wizardSessionId,
            chat_id: chat.id,
          });
        }
        else {
          closeAuto();
        }

      }
      else if(execution.status == "FAILED" || execution.status == "ABORTED") {
        onAborted();
        closeAuto();
      }
      else {
        onStep(execution);
      }

    },
    onError: (error) => { }
  });

  useEffect(() => {
    if (!chat && !execution)
      callExecuteWizard({
        node_name: mainProcessName,
        flow_id: flow.id,
        params: params,
        session_id: wizardSessionId,
      });
  }, [chat, execution]);

  useEffect(() => {
    reqGetExecutionDetails.refetch();
  }, [executionData]);

  return <div className='w-100 h-100'>

    {!hideTitle &&
      <>
        <div className={`d-flex justify-content-between align-items-center ${isCard ? "py-1 px-3 mt-2" : ""}`}>
          <h5 className="text-accent m-0 p-0">
            <i className="fas fa-wand-magic-sparkles mr-2"></i>
            {l("Asesor%GA094")} {subtitle && <span className="font-weight-normal"> - {subtitle}</span>}
          </h5>
        </div>
        <hr className="my-2" />
      </>
    }

    <div
      style={{
        opacity: isClosing ? 0.5 : 1,
        overflowY: "hidden",
        height: "100%",
        width: "100%"
      }}
    >
      {
        isWizardAvailable
          ? <>
            {
              !chat ? <Loading /> :
                <Chat
                  flow={flow}
                  chat={chat}
                  currentChat={chat}
                  chatSessionId={wizardSessionId}
                  removePadding={true}
                  isExecutionChat={true}
                  onExecutionMessage={onExecutionMessage}
                />
            }
          </>
          : <div className="d-flex flex-column justify-content-center align-items-center h-100">
            <i class="fas fa-toolbox fa-3x mb-3"></i>
            <h5 className="mb-5">
              {l("No hay un asesor disponible para esta tarea%GA100")}
            </h5>
          </div>
      }
    </div>

    <WSManager
      initialRoom={wizardRoomName}
      autoSuscribe={true}
      onMessageReceived={({ data }) => {
        if(data?.session_id == wizardSessionId)
          onWizardMessage(data);
      }}
    />

  </div>;

}

export {
  Wizard, WizardChat
};